import gql from "graphql-tag";

const GET_9089_FORM_DATA = gql`
  query getForm9089ById($id: String!) {
    getForm9089ById(id: $id) {
      formVersionId
      reuseMetadata {
        case_number
        sections
        disableSections
      }
      payload {
        linkingIsNetwork
        linkingAcknowledgedDate
        linkingAcknowledgedBy

        supervisedRecruitment
        occupationType
        jobOppPWDNumber
        jobOppPWDAttached
        empBusinessName
        empTradeName
        empAddr1
        empAddr2
        empCity
        empState
        empPostcode
        empCountry
        empProvince
        empPhone
        empPhoneext
        empFein
        empNaics
        empNaicsDesc

        empNumPayroll
        empYearCommenced
        empWorkerInterest
        empRelationshipWorker

        empPocLastName
        empPocFirstName
        empPocMiddleName
        empPocJobTitle
        empPocAddr1
        empPocAddr2
        empPocCity
        empPocState
        empPocPostalCode
        empPocCountry
        empPocProvince
        empPocPhone
        empPocPhoneExt
        empPocEmail

        attyAgRepType
        attyAgLastName
        attyAgFirstName
        attyAgMiddleName
        attyAgAddress1
        attyAgAddress2
        attyAgCity
        attyAgState
        attyAgPostalCode
        attyAgCountry
        attyAgProvince
        attyAgPhone
        attyAgPhoneExt
        attyAgEmail
        attyAgLawFirmName
        attyAgFEIN
        attyAgStateBarNumber
        attyAgGoodStandingState
        attyAgGoodStandingAttorney
        fwInfoAttyorAgent

        jobTitle

        jobOppWageFrom
        jobOppWageTo
        jobOppWagePer
        jobOppWageConditions

        faWorksiteLinked
        fwInfoAppxA_attached
        isAppdendixBAttached
        primaryWorksiteType
        primaryWorksiteAddr1
        primaryWorksiteAddr2
        primaryWorksiteCity
        primaryWorksiteCounty {
          label
          value
        }
        primaryWorksiteState
        primaryWorksitePostalCode
        primaryWorksiteBlsAreaCode
        primaryWorksiteBlsArea
        isMultipleLocations
        isAppdendixBAttached
        geograpicalArea

        pwdWorksites {
          isPrimaryWorksite
          worksiteBlsArea
          worksiteCity
          worksiteState
          worksiteCountyOrBlsArea
          worksitePostalCode
          worksiteBlsAreaId
          sort_order
        }

        appx_b_worksites {
          pwdWageRate
          pwdUnitOfPay
          sort_order
          worksiteBlsArea
          worksiteBlsAreaCode
          worksiteAddress1
          worksiteAddress2
          worksiteCity
          worksiteState
          worksitePostalCode
          worksiteCountyOrBlsArea
          worksiteCountyTownship
          dateSubmitted
          determinationDate
          rowNum
        }

        pwdHasMultipleWorksites
        swaJobOrderStartDate
        swaJobOrderEndDate
        sundayPaperExists
        newspaperNameForAd
        newspaperAdPlacedDate
        advertisementMethod
        journalNameForAd
        journalAdPlacedDate

        bargainingRep
        noBargainingRepPhysical
        noBargainingRepElectronic
        noBargainingRepInHouse
        noBargainingRepPrivate
        noBargainingRepNoNotice

        isFullTimeEmp
        isLiveInHousehold
        isPaidExperience
        isFwexecutedCont
        isEmpProvidedCont
        acceptDiplomaPwd
        isFwCurrentlyWrk
        isFwQualify
        empWillAccept
        empRelyExp
        fwGainExp
        empPayEducation
        jobEmpPremises
        jobComboOccup
        jobForeignLanguage
        jobReqExceed
        empUseCredential
        emprecpayment
        emPlayoff
        prepLastName
        prepfirstName
        prepMiddleName
        prepLawFirmFEIN
        prepFirmBusinessName
        prepEmail

        jobFairIncluded
        employerWebsiteIncluded
        jobSearchWebsiteIncluded
        onCampusRecruitingIncluded
        tradeProfessionalIncluded
        privateEmploymentIncluded
        employeeReferralIncluded
        campusPlacementIncluded
        localEthnicNewspaperIncluded
        radioTvAdIncluded
        radioTvAdFrom
        radioTvAdTo
        localEthnicNewspaperFrom
        localEthnicNewspaperTo
        campusPlacementFrom
        campusPlacementTo
        employeeReferralFrom
        employeeReferralTo
        privateEmploymentFrom
        privateEmploymentTo
        tradeProfessionalFrom
        tradeProfessionalTo
        onCampusRecruitingFrom
        onCampusRecruitingTo
        jobSearchWebsiteFrom
        jobSearchWebsiteTo
        employerWebsiteFrom
        employerWebsiteTo
        jobFairFrom
        jobFairTo

        sectionIAgreement

        appAContLastName
        appAContFirstName
        appAContMiddleName
        appAContAddress1
        appAContAddress2
        appAContCity
        appAContStateId
        appAContPostalCode
        appAContCountryId
        appAContProvince
        appAContDOB
        appAContAdmClassId
        appAContAlienReg
        appAContBirthCountryId
        appAContCitizenCountryId
        _blsCounties
        _savedPrimaryWorksite

        appendixABRequired
        fwEducationAppB {
          appAEduTypeId
          appAEduOther
          appAEduMajors
          appAEduInstName
          appAEduCountryId
          appAEduMonthYearAttained
        }

        appendixADRequired
        fwSkillsAppD {
          appASkillsInstName
          appASkillsCountryId
          appASkillsStateId
          fwTerritory
          appASkillsSpecial
        }

        appendixACRequired
        fwTrainingAppC {
          appATrainingInstName
          appATrainingName
          appATrainingCert
          appATrainingStartDate
          appATrainingEndDate
          appATrainingYearAwd
        }

        appendixAERequired
        fwExpAppE {
          appAExpEmpName
          appAExpAddress1
          appAExpAddress2
          appAExpCity
          appAExpPostalCode
          appAExpCountryId
          appAExpStateTerritory
          appAExpProvince
          appAExpJobTitle
          appAExpStartDate
          appAExpEndDate
          appAExpFWPresent
          appAExpWorkHour
          appAExpJobDuties
        }

        appCSupp {
          sectionAndItemNum
          sectionName
          suppInfo
        }

        appx_b {
          appx_b_city
          appBState
          appBCounty {
            value
            label
          }
          appBMsaName
          appBMsaCode
          _bls_counties
          sort_order
          id
          rowNum
        }
        appDForeignWorkerDate
        appDPublication1
        appDPublicationDate1
        appDPublication2
        appDPublicationDate2
        appDPublication3
        appDPublicationDate3
        appDRecruitmentInfo

        supervisedRecruitmentAttached
        playerContractAttached
        offSeasonAttached
        unionLetterAttached
        professionalAssociationAttached
        teamRevenueAttached
        playerStatisticsAttached
        pwdWageRate
        pwdUnitOfPay
        files {
          machine_name
          application_id
          FileType
          fileType
          document_name
          size
          displayName
          lastModified
          state
          percentage
          document_path
          page_index
        }
      }
      form_ui {
        pages_visited
        pages_errors
      }
    }
  }
`;

const SUBMIT_9089_FORM = gql`
  mutation SubmitForm9089(
    $id: String!
    $Form9089FormData: Form9089FormData!
    $token: String
  ) {
    SubmitForm9089(Form9089FormData: $Form9089FormData, id: $id, token: $token)
  }
`;

const UPDATE_9089_FORM = gql`
  mutation updateForm9089ById(
    $id: String!
    $Form9089FormData: Form9089FormData!
    $formUI9089: formUIInput
    $profilePrefillMetadata: [ProfilePrefillMetadataInput!]
  ) {
    updateForm9089ById(
      id: $id
      Form9089FormData: $Form9089FormData
      formUI9089: $formUI9089
      profilePrefillMetadata: $profilePrefillMetadata
    )
  }
`;

const GET_9089_PROFILES = gql`
  query {
    getUserProfileInfo {
      EmployerProfiles {
        employer_id
        employer_name
      }
      EmployerPOCProfiles {
        employer_poc_id
        employer_poc_name
      }
      AgentIndividualProfiles {
        agent_ind_id
        agent_ind_name
      }
      ForeignWorkerProfiles {
        foreign_worker_id
        foreign_worker_name
        foreign_worker_first_name
        foreign_worker_first_middle
        foreign_worker_last_name
        foreign_worker_address
        foreign_worker_city
        foreign_worker_state
        foreign_worker_province
        foreign_worker_country
        foreign_worker_postal_code
        foreign_worker_dob
        foreign_worker_class
        foreign_worker_alien_number
        foreign_worker_birth_country
        foreign_worker_citizen_country
        new_profile_fw_education {
          appAEduTypeId
          appAEduOther
          appAEduMajors
          appAEduInstName
          appAEduCountryId
          appAEduMonthYearAttained
        }
        new_profile_fw_training_qualifications {
          appATrainingInstName
          appATrainingName
          appATrainingCert
          appATrainingStartDate
          appATrainingEndDate
          appATrainingYearAwd
        }
        new_profile_fw_skills {
          appASkillsInstName
          appASkillsInstName
          appASkillsCountryId
          appASkillsStateId
          fwTerritory
          appASkillsSpecial
        }
        new_profile_fw_work_experience {
          appAExpEmpName
          appAExpAddress1
          appAExpAddress2
          appAExpCity
          appAExpPostalCode
          appAExpCountryId
          appAExpStateTerritory
          appAExpProvince
          appAExpJobTitle
          appAExpStartDate
          appAExpEndDate
          appAExpFWPresent
          appAExpWorkHour
          appAExpJobDuties
        }
      }
      ForeignWorkerGroupProfiles {
        foreign_worker_group_id
        new_group_fw_group_name
        new_group_fw_profiles
        new_group_fw_num_profiles
      }
    }
  }
`;

export {
  GET_9089_FORM_DATA,
  UPDATE_9089_FORM,
  SUBMIT_9089_FORM,
  GET_9089_PROFILES,
};
